import React from "react";
import "./LoadingSpiner.scss";

const LoadingSpinner = () => {
    return (
        <div
            className="loading-spinner-overlay"
            role="status"
            aria-label="로딩 중"
        >
            <div className="loading-spinner-container">
                <div className="loading-spinner">
                    <div className="spinner-ring"></div>
                    <div className="spinner-ring"></div>
                    <div className="spinner-ring"></div>
                </div>
                {/* {message && <p className="loading-message">{message}</p>} */}
            </div>
        </div>
    );
};

export default LoadingSpinner;
